var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10, _circle, _circle2, _circle3, _line, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRemote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 204,
    viewBox: "0 0 56 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90918 181.647V176.832H11.0681C11.9428 176.832 12.5888 177.083 13.0262 177.555C13.4278 177.99 13.6504 178.579 13.6504 179.236C13.6504 179.893 13.4211 180.526 12.9904 180.961C12.5816 181.374 11.9938 181.647 11.0681 181.647H8.90918V181.647ZM11.0396 180.563C11.52 180.563 11.7639 180.453 11.9719 180.246C12.2158 180.003 12.3523 179.701 12.3523 179.251C12.3523 178.831 12.2304 178.521 12.0077 178.278C11.7996 178.049 11.5558 177.916 11.0396 177.916H10.1642V180.564H11.0396V180.563Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4272 181.647L15.6007 176.832H16.6404L18.8139 181.647H17.4442L17.1427 180.91H15.0481L14.7539 181.647H13.4272ZM15.4496 179.907H16.7405L16.1163 178.366H16.0732L15.449 179.907H15.4496Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3574 178.175C22.0492 177.99 21.4608 177.703 20.7723 177.703C20.392 177.703 20.062 177.88 20.062 178.189C20.062 178.528 20.6 178.557 21.1089 178.609C21.9697 178.668 23.3255 178.786 23.3255 180.098C23.3255 181.315 22.3501 181.794 21.1739 181.794C19.9977 181.794 19.1442 181.33 18.5776 180.902L19.2515 180.025C19.5743 180.26 20.3204 180.784 21.152 180.784C21.7332 180.784 22.0698 180.526 22.0698 180.209C22.0698 179.863 21.6682 179.797 21.0659 179.745C20.0189 179.656 18.8062 179.546 18.8062 178.256C18.8062 177.062 19.889 176.686 20.8001 176.686C21.761 176.686 22.6145 177.017 23.0379 177.275L22.3567 178.175L22.3574 178.175Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2812 178.175C27.9731 177.99 27.3846 177.703 26.6961 177.703C26.3158 177.703 25.9858 177.88 25.9858 178.189C25.9858 178.528 26.5239 178.557 27.0328 178.609C27.8935 178.668 29.2493 178.786 29.2493 180.098C29.2493 181.315 28.2739 181.794 27.0977 181.794C25.9215 181.794 25.068 181.33 24.5015 180.902L25.1754 180.025C25.4981 180.26 26.2442 180.784 27.0758 180.784C27.657 180.784 27.9936 180.526 27.9936 180.209C27.9936 179.863 27.592 179.797 26.9897 179.745C25.9427 179.656 24.7301 179.546 24.7301 178.256C24.7301 177.062 25.8128 176.686 26.724 176.686C27.6848 176.686 28.5383 177.017 28.9617 177.275L28.2805 178.175L28.2812 178.175Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1782 176.832H33.5245V177.916H31.9825V181.647H30.7275V177.916H29.1782V176.832Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3784 180.814C40.8119 181.331 39.9657 181.795 38.9326 181.795C37.3621 181.795 36.3218 180.645 36.3218 179.237C36.3218 177.829 37.3688 176.686 38.8968 176.686C39.7576 176.686 40.6323 177.025 41.2353 177.511L40.4825 178.352C40.0452 177.983 39.4786 177.769 39.0552 177.769C38.1871 177.769 37.6279 178.44 37.6279 179.244C37.6279 180.048 38.2017 180.719 39.091 180.719C39.6363 180.719 40.2029 180.387 40.6184 179.989L41.3784 180.814Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9706 178.639L44.8141 176.832H46.4064L44.4198 178.741L46.6933 181.647H45.1368L43.5372 179.575L42.9706 180.128V181.647H41.7083V176.833H42.9706V178.639V178.639Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5437 181.647H35.0201L36.0472 176.832H34.5708L33.5437 181.647Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.399 175.182H34.9226L34.6847 176.296H36.1611L36.399 175.182Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 203,
    rx: 3.5,
    fill: "white",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 149.5H55.5V200C55.5 201.933 53.933 203.5 52 203.5H4C2.067 203.5 0.5 201.933 0.5 200V149.5Z",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 21.5449,
    r: 7.5,
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 59,
    r: 19.5,
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 59,
    r: 9.5,
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 33.4082,
    x2: 56,
    y2: 33.4082,
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 115.5,
    width: 19,
    height: 8,
    rx: 1.5,
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 126.5,
    width: 19,
    height: 8,
    rx: 1.5,
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 137.5,
    width: 19,
    height: 8,
    rx: 1.5,
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 99.5,
    width: 9,
    height: 9,
    rx: 4.5,
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 99.5,
    width: 9,
    height: 9,
    rx: 4.5,
    stroke: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 97.5,
    width: 13,
    height: 13,
    rx: 6.5,
    stroke: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 85.6992,
    width: 13,
    height: 7,
    rx: 3.5,
    stroke: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 85.6992,
    width: 13,
    height: 7,
    rx: 3.5,
    stroke: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5,
    y: 85.6992,
    width: 13,
    height: 7,
    rx: 3.5,
    stroke: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 5.5,
    width: 10,
    height: 2,
    rx: 1,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRemote);
export default __webpack_public_path__ + "static/media/ic-remote.fc2d8fa67241e7b02f6b4d8a2fea3900.svg";
export { ForwardRef as ReactComponent };